<template>
  <div class="BMC">

    <a class="bmc-button" target="_blank" href="https://www.buymeacoffee.com/textify">
      <img src="https://cdn.buymeacoffee.com/buttons/bmc-new-btn-logo.svg" alt="Buy me a coffee">
      <span>Buy me a coffee</span>
    </a>

  </div>
</template>

<script>

export default {
  name: 'BMC',
  components: {
    //Component
  },
  data: function () {
    return {
      //name: "name"
    }
  },
  props: {
  },
  computed: {
  },
  methods: {
  },
  mounted: function () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.BMC{
  text-align: center;
  font-family:'Cookie', cursive !important;
}

.bmc-button img{
  height: 20px !important;
  margin-bottom: 1px !important;
  box-shadow: none !important;
  border: none !important;
  vertical-align: middle !important;
}

.bmc-button span {
  font-size: 16pt !important;
  letter-spacing:0.6px !important;
  font-family:'Cookie', cursive !important;
  margin-left: 0.25em;
  white-space: nowrap;
}

.bmc-button{
  display: flex;
  align-items: center;
  padding: 5px 15px 5px 10px !important;
  text-decoration: none !important;
  display: inline-flex !important;
  color: #000000 !important;
  background-color:#FFDD00 !important;
  border-radius: 2px !important;
  border: 1px solid transparent !important;
  margin: 0 auto !important;

  -webkit-box-sizing: border-box !important;
  box-sizing: border-box !important;
  filter: brightness(1);
}

.bmc-button:hover, .bmc-button:active, .bmc-button:focus {
  text-decoration: none !important;
  filter: brightness(1.05);
}

</style>
